import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
  palette: {
    type: 'light',
    background: {
      default: '#ffffff',
    },
    primary: {
      main: '#cddc39',
    },
    secondary: {
      main: '#f48fb1',
    },
  },
});

export default theme;
